export class MessageModel {
    message: string;
    status: string;
    title: string;
    timeOutId: number;
}


// WEBPACK FOOTER //
// ./node_modules/@rx/view/toast/toast.models.ts